import {
  VerificationReducerActions,
  VerificationReducerStateType,
} from "@/types";

export const initialState: VerificationReducerStateType = {
  checkingVerification: true,
  alreadyVerified: false,
  needsManualVerification: false,
  documentUploadComplete: false,
  documentsHaveFailure: false,
  selfieHasFailure: false,
  documentsFailed: false,
  verificationComplete: false,
  processing: false,
  creatingTour: false,
  frontAttempts: 0,
  backAttempts: 0,
  selfieAttempts: 0,
  error: null,
};

export const verificationReducer = (
  state: VerificationReducerStateType,
  action: any
) => {
  switch (action.type) {
    case VerificationReducerActions.already_verified:
      return {
        ...state,
        alreadyVerified: true,
        needsManualVerification: false,
      };
    case VerificationReducerActions.needs_manual_verification:
      return {
        ...state,
        needsManualVerification: true,
        alreadyVerified: false,
      };
    case VerificationReducerActions.start_image_upload:
      return { ...state, processing: true };
    case VerificationReducerActions.image_upload_success:
      return { ...state, documentUploadComplete: true };
    case VerificationReducerActions.image_upload_error:
      return {
        ...state,
        error:
          action.payload.response?.data?.errors[0]?.message ||
          "An unknown error occurred",
      };
    case VerificationReducerActions.selfie_upload_failed:
      if (!state.documentsFailed) {
        return {
          ...state,
          error: action.payload.response?.data?.errors[0]?.message,
        };
      }
      return state;
    case VerificationReducerActions.documents_completed:
      return {
        ...state,
        documentUploadComplete: true,
      };
    case VerificationReducerActions.documents_have_failure:
      return {
        ...state,
        documentsHaveFailure: true,
      };
    case VerificationReducerActions.selfie_has_failure:
      return {
        ...state,
        selfieHasFailure: true,
      };
    case VerificationReducerActions.documents_failed:
      return {
        ...state,
        documentsFailed: true,
        documentUploadComplete: true,
      };
    case VerificationReducerActions.post_verification:
      return {
        ...state,
        processing: false,
        checkingVerification: false,
      };
    case VerificationReducerActions.start_finalize_tour:
      return {
        ...state,
        tourHasError: false,
        processing: false,
        creatingTour: true,
      };
    case VerificationReducerActions.finalize_tour_success:
      return { ...state, verificationComplete: true };
    case VerificationReducerActions.reset_state:
      return {
        ...initialState,
      };
    case VerificationReducerActions.set_error:
      return { ...state, error: action.payload };
    case VerificationReducerActions.update_attempts:
      return {
        ...state,
        frontAttempts: action.payload.front,
        backAttempts: action.payload.back,
        selfieAttempts: action.payload.selfie,
      };
    default:
      return state;
  }
};
